import React from "react";
import Verifications from "./Verifications";

export default function PrivateCarVerifications() {
  return <Verifications segment="private_car" title="Private Car Verification" description="Non-commercial private cars for advance bookings." />;
}
